import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const TypeTripRadios = ({isMobile, isAffiliate, isResults, showMobileTripType,
  typeTrip, setTypeTrip, translations}) => {
  const typeTrips = [
    {label: translations.oneWay},
    {label: translations.roundtrip},
    {label: translations.multiPort}
  ];
  const nOfTypes = typeTrips.length - 1;

  if (isMobile || showMobileTripType) {
    const tabClasses = classNames('grid no-gutter p-0 cursor-pointer border border-radius-lg', {
      'form-control-lg': !isAffiliate
    });

    return (
      <div className={tabClasses}>
        {typeTrips.map(({label}, index) => {

          const tripClasses = classNames('grid-item-1-3 font-normal d-flex ' +
            'justify-content-center text-center align-items-center m-0', {
            'border-right': nOfTypes !== index,
            'bg-primary': typeTrip === index,
            'text-white': typeTrip === index,
            'text-dark': !typeTrip === index,
            'rounded-right': typeTrip === nOfTypes,
            'rounded-left': typeTrip === 0,
            'h-1-1': !isAffiliate
          });

          return (
            <h5 key={index} className={tripClasses} onClick={() => setTypeTrip(index)}>
              <span style={{maxWidth: '65%'}}>{label}</span>
            </h5>
          );
        })}
      </div>
    );
  }

  return (
    <div className="d-flex">
      {typeTrips.map(({label}, index) => {
        const tripClass = classNames('radio', {
          'radio-reverse': isResults,
          'mr-3': nOfTypes !== index
        });

        return (
          <div key={index} className={tripClass}>
            <label>
              <input
                name='typeTrip'
                checked={typeTrip === index}
                type='radio'
                value={index}
                onChange={() => setTypeTrip(index)}
              />
              {label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

TypeTripRadios.defaultProps = {
  isAffiliate: false,
  isResults: false,
  showMobileTripType: false
};

TypeTripRadios.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isAffiliate: PropTypes.bool.isRequired,
  isResults: PropTypes.bool.isRequired,
  showMobileTripType: PropTypes.bool.isRequired,
  typeTrip: PropTypes.number.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    roundtrip: PropTypes.string.isRequired,
    oneWay: PropTypes.string.isRequired,
    multiPort: PropTypes.string.isRequired
  })
};

export default TypeTripRadios;
